import {ReactElement} from "react";
import {$KTM, KeyMetadatas} from "@/shared/types";
import {PD_XLG, PD_XLG2} from "@/shared/dimens";
import {colorLightPastelYellow, colorPastelGreen, gray, white} from "@/shared/colors";
import {MessageCampaignChannel, MessageCampaignName} from "@/vantage-shared/types";

type MessageCampaignCoverImageMetadata = {
  background1?: string,
  background2?: string,
  icon1: string,
  icon2: string,
}

function $KEY(channel: MessageCampaignChannel, name: MessageCampaignName): string {
  return `${channel}_${name}`;
}

const METADATA = new KeyMetadatas<MessageCampaignCoverImageMetadata>([
  $KTM($KEY(MessageCampaignChannel.EMAIL, MessageCampaignName.BIRTHDAY), {
    background1: white,
    background2: gray,
    icon1: "/icons/email.svg",
    icon2: "/icons/birthday.svg"
  }),
  $KTM($KEY(MessageCampaignChannel.EMAIL, MessageCampaignName.FESTIVAL), {
    background1: white,
    background2: colorLightPastelYellow,
    icon1: "/icons/email.svg",
    icon2: "/icons/festival.svg"
  }),
  $KTM($KEY(MessageCampaignChannel.SMS, MessageCampaignName.BIRTHDAY), {
    background1: white,
    background2: gray,
    icon1: "/icons/sms.svg",
    icon2: "/icons/birthday.svg"
  }),
  $KTM($KEY(MessageCampaignChannel.SMS, MessageCampaignName.FESTIVAL), {
    background1: white,
    background2: colorLightPastelYellow,
    icon1: "/icons/sms.svg",
    icon2: "/icons/festival.svg"
  }),
  $KTM($KEY(MessageCampaignChannel.WHATSAPP, MessageCampaignName.BIRTHDAY), {
    background1: colorPastelGreen,
    background2: gray,
    icon1: "/icons/whatsapp.svg",
    icon2: "/icons/birthday.svg"
  }),
  $KTM($KEY(MessageCampaignChannel.WHATSAPP, MessageCampaignName.FESTIVAL), {
    background1: colorPastelGreen,
    background2: colorLightPastelYellow,
    icon1: "/icons/whatsapp.svg",
    icon2: "/icons/festival.svg"
  }),
]);

export function MessageCampaignCoverImage({channel, name}: {
  channel: MessageCampaignChannel,
  name: MessageCampaignName
}): ReactElement {
  const metadata = METADATA.findMetadata($KEY(channel, name));
  return <div style={{width: "100%", aspectRatio: 1, padding: PD_XLG2}}>
    <div style={{width: "100%", height: "100%", position: "relative"}}>
      <img src={metadata.icon1} style={{
        position: "absolute",
        padding: PD_XLG,
        background: metadata.background1 || "white",
        width: "50%",
        aspectRatio: 1,
        top: 0,
        left: 0,
      }}/>
      <img src={metadata.icon2} style={{
        position: "absolute",
        padding: PD_XLG,
        background: metadata.background2 || "white",
        width: "50%",
        aspectRatio: 1,
        bottom: 0,
        right: 0
      }}/>
    </div>
  </div>;
}